import AI from './Ai.vue'

export default AI
